//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { declarationRecordQueryPage, decalarListDC, BASE, BASE_PATH } from '@/api/importedColdChain';
import { download, getExcelPath } from "@/api/baseDataManage";
export default {
  name: 'declarationRecord',
  data: function data() {
    return {
      decalarListDC: true,
      baseUrl: BASE + BASE_PATH,
      // 查询条件
      form: {
        pageNo: 1,
        pageSize: 10,
        cargoApplicationNo: '',
        inStartDate: '',
        inEndDate: '',
        customsListNo: '',
        protocolNo: '',
        applicationNo: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [{
        companyCode: "1121",
        companyName: "12312"
      }],
      loading: false
    };
  },
  mounted: function mounted() {
    // 加载数据
    this.getData();
  },
  filters: {
    protoStatus: function protoStatus(value) {
      if (value == '1') return '未申报';else if (value == '2') return '已申报';else return '未申报';
    }
  },
  methods: {
    //   查询
    submitForm: function submitForm() {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.form.cargoApplicationNo = this.form.cargoApplicationNo || '';
      this.form.inStartDate = this.form.inStartDate || '';
      this.form.inEndDate = this.form.inEndDate || '';
      this.form.customsListNo = this.form.customsListNo || '';
      this.form.applicationNo = this.form.applicationNo || '';
      this.form.protocolNo = this.form.protocolNo || '';
      declarationRecordQueryPage(this.form).then(function (res) {
        _this.loading = false;
        _this.total = res.totalCount;
        _this.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm() {
      this.form.applicationNo = '';
      this.form.inStartDate = '';
      this.form.endDate = '';
      this.form.inEndDate = '';
      this.form.cargoApplicationNo = '';
      this.form.protocolNo = '';
      this.form.customsListNo = '';
    },
    // 货物申报结算清单导出
    listDeclarDC: function listDeclarDC() {
      decalarListDC({
        applicationNo: this.form.applicationNo || '',
        protocolNo: this.form.protocolNo || '',
        inStartDate: this.form.inStartDate || '',
        inEndDate: this.form.inEndDate || '',
        customsListNo: this.form.customsListNo || '',
        cargoApplicationNo: this.form.cargoApplicationNo || ''
      }).then(function (res) {
        var blob = new Blob([res], {
          type: 'application/vnd.ms-excel'
        }); // 兼容ie

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, '货物申报记录清单.xls');
        } else {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a'); // 创建a标签

          link.href = url;
          link.download = '货物申报记录清单.xls'; // 重命名文件

          link.click();
          window.URL.revokeObjectURL(url); // 释放内存
        }
      });
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    showDetail: function showDetail(data) {
      var params = {
        cargoApplicationNo: data.cargoApplicationNo || '',
        applicationNo: data.applicationNo || '',
        protocolNo: data.protocolNo || '',
        customsListNo: data.customsListNo || ''
      };
      console.log(params);
      this.$router.push({
        name: 'declarationRecordDetail',
        params: params
      });
    }
  }
};